module.exports = __webpack_public_path__ + "static/media/minDays.28f23b65.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/objects/other/minDays.svg
// module id = 886
// module chunks = 0